import * as marietta from '../..';
import {ModelLoadSystem} from "../../view3d/webcad/WebCad3dModelLoadSystem";
import { BUILDING_TYPE_MANSION, ITEM_MODE_NO } from '../Constants';
import * as marietta3d from '../../view3d';
import { ThreeView } from '../../view3d/webcad';
import { GradeTypeSelectDialog } from './dialog';
import { GradeMasterCollection } from '../collection';

class DimensionMenu {
    mode: string = '2D';

    restrictBtn3DEvent: any;

    restrictChangeMode3DEvent: any;

    /**
     * コンストラクタ
     */
    constructor() {
      // 3D用のエレメントを非表示

      document.querySelectorAll('.for3D').forEach((_elem:HTMLElement) => {
        const elem = _elem;
        elem.style.display = 'none';
      });
      // 2D/3Dボタンイベント
      const btn2D: Element = document.querySelector('#btn2D');
      const btn3D: Element = document.querySelector('#btn3D');
      btn2D.addEventListener('click', this.btn2DEventHandler);
      btn3D.addEventListener('click', this.btn3DEventHandler);
    }

    /**
     * 2Dボタンが押された
     */

    btn2DEventHandler = () => {
      console.log('changeMode 2d');
      this.changeMode2D();
    }

    /**
     * 3Dボタンが押された
     */
    btn3DEventHandler = (e: MouseEvent) => {
      // 3D対応していなければ、遷移しない
      if (!marietta.webcad.WebCADGlobal.capableWebGL()) {
        marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_3D_COMPATIBILITY'));
        return;
      }

      // 屋根の手動・自動によってメニュ―の中身を変える
      this.settingRoof();

      // 高画質レンダリング開始ボタンの初期化
      // const element = (document.getElementById('btnRendering') as HTMLButtonElement);
      // element.value = 'start';
      // element.innerHTML = '<span class="jp">高画質レンダリング 依頼</span><span class="en">High quality rendering start</span>';

      const self = this;
      // アイテムコントローラーをなくす
      marietta.webcad.WebCADGlobal.itemManager.deleteUnplacedItems();
      marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
      marietta.webcad.WebCADGlobal.itemManager.currentItemGroup = null;

      e?.preventDefault();

      if (this.restrictBtn3DEvent) console.log('changeMode', this.restrictBtn3DEvent);
      clearTimeout(this.restrictBtn3DEvent);

      this.restrictBtn3DEvent = setTimeout(() => {
        console.log('changeMode 3d');
        // 1Fに玄関がなければ、遷移しない
        const floorLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(1) as marietta.webcad.layer.FloorLayer;
        const tarLayer = floorLayer.layer_room as marietta.webcad.layer.ItemLayer;
        if (tarLayer.hasItemByCode('rom03_01') === false) {
          // 3Dモードには玄関が必要です。<br>玄関を入力してください。
          marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_NEED_ENTRANCE'), marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
          return;
        }
        // 階段があるのに、上層階に入力されていない場合、遷移しない
        for (let floor = 1; floor < marietta.WebCADGlobal.MAX_FLOORS; floor += 1) {
          const targetFloor = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(floor) as marietta.webcad.layer.FloorLayer;
          const stairLayer = targetFloor.layer_stair as marietta.webcad.layer.ItemLayer;
          if (stairLayer.isItemInMe() === true) {
            if (!self.checkUpstairRoomInput(floor + 1)) {
              switch (floor) {
                case 1:
                  // 2Fに部屋がありません。<br>部屋を入力してください。
                  marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_NEED_2NDFLOOR'), marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
                  return;
                case 2:
                  // 3Fに部屋がありません。<br>部屋を入力してください。
                  marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_NEED_3RDFLOOR'), marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
                  return;
                default:
                  break;
              }
            }
          }
        }

        // 自動廊下生成
        marietta.webcad.WebCADGlobal.cadAPIManager.checkAutoHallways(
          () => {
            // ビジーフィルタ
            marietta.webcad.WebCADGlobal.showBusy();
            // 離れた部屋があるか否かチェック。あれば遷移しない
            marietta.webcad.WebCADGlobal.cadAPIManager.apiHasSeperatedRoom(self.onCheckRoomApartDone);
          },
        );
      }, 0);
    }

    /**
     * 屋根の手動・自動によってメニュ―の中身を変える
     */
    public settingRoof() {
      // 1個目の屋根であればダイアログを表示する
      const itemList: marietta.webcad.item.Roof[] = <marietta.webcad.item.Roof[]>marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOF_NO);
      if (itemList.length > 0) {
        (document).querySelectorAll('.autoRoof').forEach((_elem: HTMLElement) => {
          const elem = _elem;
          elem.style.display = 'none';
        });
        (document).querySelectorAll('.manualRoof').forEach((_elem: HTMLElement) => {
          const elem = _elem;
          elem.style.display = 'block';
        });
      } else {
        (document).querySelectorAll('.autoRoof').forEach((_elem: HTMLElement) => {
          const elem = _elem;
          elem.style.display = 'block';
        });
        (document).querySelectorAll('.manualRoof').forEach((_elem: HTMLElement) => {
          const elem = _elem;
          elem.style.display = 'none';
        });
      }
    }

    /**
     * 上階の部屋の入力を確認する
     */
    checkUpstairRoomInput = (floor: number): boolean => {
      const floorLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(floor) as marietta.webcad.layer.FloorLayer;
      const itemLayer1 = floorLayer.layer_room as marietta.webcad.layer.ItemLayer;
      const itemLayer2 = floorLayer.layer_roomdown1 as marietta.webcad.layer.ItemLayer;
      const itemLayer3 = floorLayer.layer_roomdown2 as marietta.webcad.layer.ItemLayer;
      if (itemLayer1.isItemInMe() || itemLayer2.isItemInMe() || itemLayer3.isItemInMe()) {
        return true;
      }
      return false;
    }

    /**
     * 離れた部屋があるか否かのチェック
     */
    onCheckRoomApartDone = (result: boolean) => {
      // ビジーフィルタ
      marietta.webcad.WebCADGlobal.hideBusy();

      if (result) {
        // 隣接していない部屋があります。 <br>間取りを修正してください。
        marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_HAS_SEPERATED_ROOM'), marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
        return;
      }
      const self = this;

      // ビジーフィルタ
      marietta.webcad.WebCADGlobal.showBusy();

      // オンラインチェックをしてから、自動廊下生成
      marietta.webcad.WebCADGlobal.checkOnlineAnd(self.oncheckAutoHallwaysDoneCheckAutoFittings);
    }

    // オンラインチェックをしてから、自動廊下生成チェック
    onCheckOnlineAndDoneCheckAutoHallways = () => {
      const self = this;
      marietta.webcad.WebCADGlobal.cadAPIManager.checkAutoHallways(self.oncheckAutoHallwaysDoneCheckAutoFittings);
    }

    // オンラインチェックをしてから、自動建具生成
    oncheckAutoHallwaysDoneCheckAutoFittings = () => {
      // ビジーフィルタ
      marietta.webcad.WebCADGlobal.hideBusy();

      // const self = this;
      // self.checkAutoFittings(self.onCheckAutoFittingscheckModelParam);

      const self = this;
      self.checkModelParam(self.changeMode3D);
    }

    // // オンラインチェックをしてから、モデルパラム取得
    // onCheckAutoFittingscheckModelParam = () => {
    //   // ビジーフィルタ
    //   // marietta.webcad.WebCADGlobal.showBusy();
    //
    //   const self = this;
    //   self.checkModelParam(self.changeMode3D);
    // }

    /**
     * 建具自動生成の判別
     */
    checkAutoFittings = (cb: Function) => {
      let fittingsList = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_FITTING_NO);
      if (fittingsList.length <= 0) {
        marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.ConfirmGenerateFittingsDialog);
      } else {
        // 1Fに建具がなければ判定はNG
        const tarLayer1: marietta.webcad.layer.ItemLayer = marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(1, ITEM_MODE_NO.MODE_FITTING_NO);
        fittingsList = tarLayer1.getAllChildren();
        if (fittingsList.length <= 0) {
          marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.ConfirmGenerateFittingsDialog3);
        } else {
          cb();
        }
      }
    }

    /**
     * 3Dスタイル設定の判別
     */
    checkModelParam = (cb: Function) => {
      //建物スタイルを固定にする
      this.styleFixed();

      // デバッグモードとシェアモードでは、グレードを設定させずに3Dへ移行する
      if (marietta.WebCADGlobal.DEBUG_MODE || marietta.webcad.WebCADGlobal.shareModeManager.isShareMode) {
        cb();
        return;
      }

      if ( (marietta.webcad.WebCADGlobal.webcad2Dmanager.grade == undefined || marietta.webcad.WebCADGlobal.webcad2Dmanager.grade == null) && marietta.webcad.WebCADGlobal.webcad2Dmanager.operation_type == 1 ) {
        let dialog:GradeTypeSelectDialog = marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.GradeTypeSelectDialog) as GradeTypeSelectDialog;
        dialog.callBack = ( grade:GradeMasterCollection, list:any[]　) => {
          //全体に設定
          marietta.webcad.WebCADGlobal.webcad2Dmanager.grade = grade;
          //マスタに更新
          if( list ) marietta.WebCADGlobal.webcad2Dmanager.grade.updateItemList( list );

          //アイテムのグル―ドを設定する
          const p = new Promise((resolve: Function) => {
            marietta.webcad.WebCADGlobal.itemManager.setAllItemsToGrade(resolve);
          });
          p.then(() => {
            //3D表示
            cb();
          });
        };
      }else{
        cb();
      }
    }

    /**
     * 建物スタイルを固定にする
     */
    public styleFixed() {
      if (!marietta.webcad.WebCADGlobal.webcad2Dmanager.modelParam || marietta.webcad.WebCADGlobal.webcad2Dmanager.modelParam == null) {
        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
          marietta.webcad.WebCADGlobal.buildStyleManager.setStyle(0, 'assets/buildStyle/style_mansion.json');
        }else {
          marietta.webcad.WebCADGlobal.buildStyleManager.setStyle(0, 'assets/buildStyle/style1.json');
        }
      }
    }

    /**
     * 2Dモードへ移行
     */
    changeMode2D = () => {
      if (this.mode === '2D') return;
      // 選択モードへ変更
      document.getElementById('checkSelectMode').click();

      // アイテムコントローラーの削除
      marietta.webcad.WebCADGlobal.itemManager.currentItem = null;

      // モード変更
      this.mode = '2D';
      (document).querySelectorAll('.for2D').forEach((_elem:HTMLElement) => {
        const elem = _elem;
        elem.style.display = 'block';
      });
      (document).querySelectorAll('.for3D').forEach((_elem:HTMLElement) => {
        const elem = _elem;
        elem.style.display = 'none';
      });

      marietta.webcad.WebCADGlobal.webcad2Dmanager.enableViewMode();

      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.mode === '2') {
        // 参照モードへ
        document.getElementById('itemMenuWrap').style.display = 'none';
        document.getElementById('headerMenu2D').style.display = 'none';
        document.getElementById('itemControlPanel').style.display = 'none';
        document.getElementById('itemChangeMenuWrap').style.display = 'none';
      }

      // ステージ、メニューサイズ調整
      marietta.webcad.WebCADGlobal.onStageResized();

      marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementFit();

      // 表示中のダイアログを消す
      marietta.webcad.WebCADGlobal.removeDialog();

      // // 3D内観ビューのカメラ情報を保持
      // marietta.view3d.webcad.View3dGlobal.shared.saveCameraState();

      // // binaryデータとextrasの初期化
      // marietta.view3d.webcad.View3dGlobal.threeView.wcItemmgr.resetData();

      // if (marietta3d.webcad.ThreeView.get().selectManager != null) {
      //   marietta3d.webcad.ThreeView.get().selectManager.reset();
      // }
      this.finished3d();

      // 計測ツール
      document.getElementById('btnMesureParent').style.display = 'none';
      const mesureInfo = document.getElementById('mesureInfo');
      if (mesureInfo) {
          mesureInfo.style.display = 'none';
      }
      if (ThreeView.get().measureTool) {
        ThreeView.get().measureTool.resetTool();
      }

      // Pixelstreaming接続解除
      const pscommunication = marietta3d.webcad.ThreeView.get().pscommunication;
      pscommunication.disconnect();
    }

    /** 3D→2Dモードへ移行する際の3Dの初期化/保存処理 */
    public finished3d() {
      // 3D内観ビューのカメラ情報を保持
      marietta.view3d.webcad.View3dGlobal.shared.saveCameraState();

      // binaryデータとextrasの初期化
      marietta.view3d.webcad.View3dGlobal.threeView.wcItemmgr.resetData();

      if (marietta3d.webcad.ThreeView.get().selectManager != null) {
        marietta3d.webcad.ThreeView.get().selectManager.reset();
      }
    }

    /**
     * 3Dモードへ移行
     */
    changeMode3D = () => {
      // document.getElementById('streamingLogContainer').innerHTML = ''; // todo: temporary for logging
      // if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
      //   document.getElementById('cameraToggleBtn').style.display = 'none';
      //   document.getElementById('changeCamToggleCol').style.display = 'none';
      //   (<HTMLElement>document.querySelector('.oneFooterMenuLeft .menuSep')).style.display = 'none';
      // } else {
        document.getElementById('cameraToggleBtn').style.display = 'inline-block';
        document.getElementById('changeCamToggleCol').style.display = 'inline-block';
        (<HTMLElement>document.querySelector('.oneFooterMenuLeft .menuSep')).style.display = 'block';
      // }
      // 3D対応していなければ、遷移しない
      if (!marietta.webcad.WebCADGlobal.capableWebGL()) {
        marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_3D_COMPATIBILITY'));
        return;
      }

      const self = this;
      console.log('changeMode modechange', this.restrictChangeMode3DEvent);
      clearTimeout(this.restrictChangeMode3DEvent);
      this.restrictChangeMode3DEvent = setTimeout(() => {
        marietta.webcad.WebCADGlobal.showBusy(marietta.webcad.collection.WebCADMessages.getText('BUSY_PREPARING_DATA'), self.onShowBusyDoneCheckItemSize);

        // 表示中のダイアログを消す
        marietta.webcad.WebCADGlobal.removeDialog();

        marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementFit();

        // ライン測定を更新する
        marietta.webcad.WebCADGlobal.updateMeasureLine(false);
      }, 0);

      if (ThreeView.get().selectManager) {
        ThreeView.get().selectManager.invalidate = false;   // 選択可能
      }
      // 計測ツール表示
      const isNaikan = ThreeView.get().cameras.isWalkThroughCameraMode();
      if (isNaikan) {
        document.getElementById('btnMesureParent').style.display = 'block';
      }
    }

    /**
     * ビジー表示完了後、アイテム数確認
     */
    onShowBusyDoneCheckItemSize = () => {
      const self = this;
      console.log('checkItemSize');
      self.checkItemSize(self.onCheckItemSizeDoneCreateMiniMap);
    }

    /**
     * アイテムの個数を確認
     */
    checkItemSize = (cb: Function) => {
      const checkItemSize = marietta.webcad.WebCADGlobal.webcad2Dmanager.checkItemSize();
      if (checkItemSize !== '') {
        marietta.webcad.WebCADGlobal.hideBusy();
        marietta.webcad.WebCADGlobal.showAlert(checkItemSize, marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
        return;
      }
      marietta.webcad.WebCADGlobal.hideBusy(); // showbusy 回収.
      // フィルターを表示
      marietta.webcad.WebCADGlobal.showBusy();
      setTimeout(() => {
        // フィルタを削除
        marietta.webcad.WebCADGlobal.hideBusy();
        cb();
      }, 500);
    }

    /**
     * アイテム個数の確認後、ミニマップの作成へ
     */
    onCheckItemSizeDoneCreateMiniMap = () => {
      const self = this;
      setTimeout(() => {
        self.createMiniMap(self.onCreateMiniMapDoneParseJson);
      }, 0);
    }

    /**
     * ミニマップの作成
     */
    createMiniMap(cb: Function) {
      if (this.mode === '2D') {
        marietta.webcad.WebCADGlobal.miniMapManager.createMiniMap(cb);
      } else {
        cb();
      }
    }

    /**
     * ミニマップ作成完了後、xmlデータの受け渡しへ
     */
    onCreateMiniMapDoneParseXml = () => {
      const self = this;
      self.parseXml(self.onParseXmlDoneRequest3D);
    }

    /**
     * ミニマップ作成完了後、jsonデータの受け渡しへ
     */
     onCreateMiniMapDoneParseJson = () => {
       const self = this;
       self.parseJson(self.onParseXmlDoneRequest3D);
     }

     /**
     * xmlデータの作成＆3Dへ受け渡し
     */
     parseJson = (cb: Function) => {
       // XML作成
       const json = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
       marietta.webcad.WebCADGlobal.autoMain.parseJSON(json);
       cb();
     }

    /**
     * xmlデータの作成＆3Dへ受け渡し
     */
    parseXml = (cb: Function) => {
      // XML作成
      const xml: XMLDocument = marietta.webcad.WebCADGlobal.webcad2Dmanager.getSaveData();
      const xmlSerializer = new XMLSerializer();
      const xmlString: string = xmlSerializer.serializeToString(xml);
      // 3D側にXML受け渡し
      marietta.webcad.WebCADGlobal.autoMain.perseXML(xmlString);
      cb();
    }

    /**
     * xmlデータの受け渡し後、3Dリクエスト実行
     */
    onParseXmlDoneRequest3D = () => {
      new ModelLoadSystem().request3D();
    }

    btnUpdate() {
      document.querySelector('#changeDimensionBtns').querySelector('button').classList.remove('is-active');
      if (this.mode === '3D') {
        document.querySelector('#btn3D').classList.add('is-active');
      } else {
        document.querySelector('#btn2D').classList.add('is-active');
      }
    }

    /**
     * XMLチェック model_paramノードの有無判定
     */
    hasModelParamNode = (): boolean => document.querySelector('model_param')[0] !== null
}
export default DimensionMenu;
